import React, { useState } from "react";
import { fetchExecutors, deleteExecuter } from "./SkeyeingestExecutorApi";
import SkeyeingestExecutorTable from "./SkeyeingestExecutorTable";
import SkeyeingestAddExecutorDialog from "./SkeyeingestAddExecutorDialog";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import useIsRoleUser from "../../../hooks/useIsRoleUser";
import skeyeingestExecutorsHelp from "../../../content/help/skeyeingest-executors.json";

export default function SkeyeingestExecutors({
  pageTitle = "Skeyeingest Executors",
}) {
  usePageTitle("SkeyeIngest Executors - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    loadData,
    onPageChange,
  } = usePageState({
    fetchFn: fetchExecutors,
    filterFields: ["id", "filename", "createdAt"],
  });

  const [addModalOpen, setAddModalOpen] = useState(false);
  const isRoleUser = useIsRoleUser();

  const handleDeleteExecutor = async (id) => {
    try {
      await deleteExecuter(id);
      messageApi.success("Executor deleted successfully.");
      loadData();
    } catch (error) {
      messageApi.error("Failed to delete executor.");
    }
  };

  return (
    <PageLayout
      title={pageTitle}
      logo="/img/majesteye-icon-skeye-ingest-square-white-background-no-label"
      description="Manager for Skeyeingest executors, allowing you to upload and organize your executor configurations in one place."
      helpContent={skeyeingestExecutorsHelp}
    >
      {contextHolder}
      <SearchToolbar
        search={searchText}
        onSearchChange={handleSearch}
        onClearFilter={clearFilter}
        addButtonLabel="Add Executor"
        onAdd={() => setAddModalOpen(true)}
        showAdd={!isRoleUser}
      />
      <SkeyeingestExecutorTable
        data={filteredData}
        loading={loading}
        page={page}
        pageSize={pageSize}
        onPageChange={onPageChange}
        onDeleteExecutor={handleDeleteExecutor}
        isRoleUser={isRoleUser}
      />
      <SkeyeingestAddExecutorDialog
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onSuccess={loadData}
        messageApi={messageApi}
      />
    </PageLayout>
  );
}
